import React, { useState } from "react";

const MAX_LENGTH = 300; // Characters to show before "Read More"

const ResultItem = ({ content }) => {
  const [expanded, setExpanded] = useState(false);

  const isLong = content.length > MAX_LENGTH;
  const displayedText = expanded || !isLong ? content : content.slice(0, MAX_LENGTH) + "...";

  return (
    <li className="result-item">
      <p>{displayedText}</p>
      {isLong && (
        <button className="read-more-btn" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
    </li>
  );
};

const SearchResults = ({ results }) => {
  if (!results) return null;

  if (!Array.isArray(results)) {
    return <p className="no-results">Unexpected results format.</p>;
  }

  if (results.length === 0) return <p className="no-results">No results found.</p>;

  return (
    <div className="results-container">
      <h3>Results:</h3>
      <ul className="results-list">
        {results.map((item, index) => (
          <ResultItem key={index} content={item} />
        ))}
      </ul>
    </div>
  );
};

export default SearchResults;
